var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
export var Icon = styled(function (props) { return React.createElement(FontAwesomeIcon, __assign({}, props)); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (props) {
    return props.color || props.theme.darkMode
        ? props.theme.interface4
        : props.theme.brand_primary_color;
});
export var IconHover = styled(function (props) { return (React.createElement(FontAwesomeIcon, __assign({}, props))); })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: none;\n  color: ", ";\n  width: 15px;\n  height: 15px;\n  background: url(", ") center center no-repeat padding-box;\n"], ["\n  display: none;\n  color: ", ";\n  width: 15px;\n  height: 15px;\n  background: url(", ") center center no-repeat padding-box;\n"])), function (props) { return props.theme.interface1; }, function (props) { return props.icon; });
export var IconAvatar = styled.img(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 0;\n  height: 0;\n  border-radius: 50%;\n"], ["\n  width: 0;\n  height: 0;\n  border-radius: 50%;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
